<template>
  <v-main style="height: 100%">
    <v-container fluid class="justify-center align-center fill-height gradientBackground">
      <v-row class="justify-center">
        <v-col cols="12" md="12" v-if="!loading">

          <v-card class="elevation-12  rounded-xl">
            <!--          titulo -->
            <v-card-title class="justify-space-between align-center">
              <h2 class="headline mb-0">Ficha de Atención:<br > {{ paciente.name }}</h2>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on">descargar ficha</v-btn>
                </template>
              <v-list>
                <v-list-item style="cursor: pointer;">
                  <v-list-item-title @click="getPdfList">Listado</v-list-item-title>
                </v-list-item>
                <v-list-item style="cursor: pointer;">
                  <v-list-item-title @click="getPdfForms">Formularios</v-list-item-title>
                </v-list-item>
              </v-list>
           </v-menu>
            </v-card-title>
            <!-- datos del paciente -->
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field
                      v-model="paciente.name"
                      label="Nombre"
                      outlined
                      dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field
                      v-model="paciente.rut"
                      label="RUT"
                      outlined
                      dense
                      readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field
                      v-model="paciente.phone"
                      label="Telefono"
                      outlined
                      dense
                      :rules="telefonoRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field
                      v-model="paciente.email"
                      label="Email"
                      outlined
                      dense
                      :rules="emailRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field
                      v-model="paciente.address"
                      label="Direccion"
                      outlined
                      dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                      <v-menu
                          ref="menuBirth"
                          v-model="menuBirth"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              v-model="paciente.birthday"
                              label="Fecha de Nacimiento"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              outlined
                              class="inputForm"

                              dense
                          ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="paciente.birthday"
                            :active-picker.sync="activePicker"
                            :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                            min="1923-01-01"
                            @change="saveDateBirth"
                        ></v-date-picker>
                      </v-menu>
                </v-col>
              </v-row>

            <div style="display:flex; justify-content: space-between;">
              <v-btn
                  v-if="nuevoRegistroDisponible"
                  color="primary"
                  class="white--text"
                  @click="agregarRegistro"
              >
                Nuevo Registro
              </v-btn>

            <v-btn
              color="primary"
              class="white--text"
              @click="editPaciente"
              :disabled="!paciente.name || !paciente.birthday || !paciente.phone || !paciente.email || !paciente.address"
              >
                Guardar Cambios
              </v-btn>
            </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="12"  v-if="nuevoRegistro">
          <v-card class="elevation-12 rounded ">
            <v-card-title class="justify-center align-center">
              <h2 class="headline mb-0">Nuevo Registro</h2>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field
                      v-model="registro.doctor"
                      label="Atención"
                      outlined
                      dense
                      readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="4" v-if="this.$route.query.especialidad">
                  <v-text-field
                      v-model="registro.specialty"
                      label="Categoría"
                      outlined
                      dense
                      readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                <v-select
                  :items="abogados"
                  label="Abogado"
                  v-model="abogado"
                  outlined
                ></v-select>
                </v-col>
                <v-col cols="12" md="12" lg="12">
                  <v-text-field
                      v-model="short_description"
                      label="Descripción problematica"
                      outlined
                      dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12" lg="12">
                  <v-textarea
                      v-model="registro.description"
                      label="Descripcion"
                      outlined
                      dense
                  ></v-textarea>
                </v-col>
              </v-row>

              <!--              botones para cancelar o guardar nuevo registro-->
              <v-card-actions>
                <v-btn
                    color="primary"
                    class="white--text"
                    outlined
                    @click="cancelNuevoRegistro"
                >
                  Cancelar
                </v-btn>
                <v-btn
                    color="primary"
                    class="white--text"
                    @click="guardarNuevoRegistro"
                >
                  Guardar
                </v-btn>
              </v-card-actions>
            </v-card-text>

          </v-card>
        </v-col>


        <v-col cols="12">


            <v-card class="elevation-12  rounded-xl ">

              <!--          lista de registros medico con expansion pannel-->
              <v-card-title class="justify-center align-center">
                <h2 class="headline mb-0">Registros de Atención</h2>
              </v-card-title>

                  <v-expansion-panels>
                    <v-expansion-panel
                        v-for="(item, i) in registros"
                        :key="i"
                    >
                      <v-expansion-panel-header>
                        {{ item.doctor_name }} - {{ item.specialty_name }} - {{ formatDate(item.created_at) }}
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card-text>
                          <v-row>
                            <v-col cols="12" md="6" lg="4">
                              <v-text-field
                                  v-model="item.doctor_name"
                                  label="Atención"
                                  outlined
                                  dense
                                  readonly
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6" lg="4">
                              <v-text-field
                                  v-model="item.specialty_name"
                                  label="Categoría"
                                  outlined
                                  dense
                                  readonly
                              ></v-text-field>
                            </v-col>
<!--                            update_at-->
                            <v-col cols="12" md="6" lg="4">
                              <v-text-field
                                  :value="formatDate(item.created_at)"
                                  label="Fecha"
                                  outlined
                                  dense
                                  readonly
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="12" lg="12">
                              <v-text-field
                                  v-model="item.short_description"
                                  label="Descripción problemática"
                                  outlined
                                  dense
                                  readonly
                              ></v-text-field>
                            </v-col>

                            <v-col cols="12" md="12" lg="12">
                              <v-textarea
                                  v-model="item.description"
                                  label="Descripcion"
                                  outlined
                                  dense
                                  readonly
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
            </v-card>
        </v-col>
        <v-col cols="12" md="6" v-if="loading">
          <v-card class="elevation-12 rounded ">
            <v-card-title class="justify-center align-center">
              <h2 class="headline mb-0">Cargando...</h2>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
      <v-snackbar
          v-model="showMessage"
          vertical
          bottom
          center
          :color="messageColor"
      >
        <p class="mb-0">{{ message }}</p>
      </v-snackbar>
    </v-container>


<!--       PDFS -->
      <VueHtml2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :paginate-elements-by-height="800"
        :filename="'ficha' + '' + paciente.name"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="700px"
        ref="html2PdfList"
    >
            <section slot="pdf-content">
                        <v-card-text>
              <v-row>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field
                      v-model="paciente.name"
                      label="Nombre"
                      outlined
                      dense
                      readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field
                      v-model="paciente.rut"
                      label="RUT"
                      outlined
                      dense
                      readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field
                      v-model="paciente.phone"
                      label="Telefono"
                      outlined
                      dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field
                      v-model="paciente.email"
                      label="Email"
                      outlined
                      dense
                      readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field
                      v-model="paciente.address"
                      label="Direccion"
                      outlined
                      dense
                      readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field
                      v-model="paciente.birthday"
                      label="Fecha de Nacimiento"
                      outlined
                      dense
                      readonly
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

              <v-data-table
                :headers="headersPdf"
                :items="registros"
                :items-per-page="registros.length"
                class="elevation-1"
              >
              <template v-slot:item.created_at="{ item }">
              {{ formatDate(item.created_at) }}
              </template>
              </v-data-table>

            </section>
      </VueHtml2pdf>

      <VueHtml2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :paginate-elements-by-height="800"
        :filename="'ficha' + '' + paciente.name"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="700px"
        ref="html2PdfForms"
    >
            <section slot="pdf-content">
                        <v-card-text>
              <v-row>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field
                      v-model="paciente.name"
                      label="Nombre"
                      outlined
                      dense
                      readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field
                      v-model="paciente.rut"
                      label="RUT"
                      outlined
                      dense
                      readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field
                      v-model="paciente.phone"
                      label="Telefono"
                      outlined
                      dense
                      readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field
                      v-model="paciente.email"
                      label="Email"
                      outlined
                      dense
                      readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field
                      v-model="paciente.address"
                      label="Direccion"
                      outlined
                      dense
                      readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field
                      v-model="paciente.birthday"
                      label="Fecha de Nacimiento"
                      outlined
                      dense
                      readonly
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
                                      <v-card-text v-for="(item, i) in registros" :key="i">
                          <v-row>
                            <v-col cols="12" md="6" lg="4">
                              <v-text-field
                                  v-model="item.doctor_name"
                                  label="Atención"
                                  outlined
                                  dense
                                  readonly
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6" lg="4">
                              <v-text-field
                                  v-model="item.specialty_name"
                                  label="Categoría"
                                  outlined
                                  dense
                                  readonly
                              ></v-text-field>
                            </v-col>
<!--                            update_at-->
                            <v-col cols="12" md="6" lg="4">
                              <v-text-field
                                  :value="formatDate(item.created_at)"
                                  label="Fecha"
                                  outlined
                                  dense
                                  readonly
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="12" lg="12">
                              <v-text-field
                                  v-model="item.short_description"
                                  label="Descripción problemática"
                                  outlined
                                  dense
                                  readonly
                              ></v-text-field>
                            </v-col>

                            <v-col cols="12" md="12" lg="12">
                              <v-textarea
                                  v-model="item.description"
                                  label="Descripcion"
                                  outlined
                                  dense
                                  readonly
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </v-card-text>
            </section>
      </VueHtml2pdf>
  </v-main>
</template>

<script>
import {validate, format} from 'rut.js';
import VueHtml2pdf from 'vue-html2pdf'
import moment from "moment";
import {
  createMedicalRecord,
  getMedicalRecords,
  getPatientById,
  getSpecialtyById,
  getListSpecialties,
  getMedicalAppointment_byid,
  createPatient
  } from "@/helpers/api/horas_medicas";
import Swal from "sweetalert2";

export default {
  components: {
    VueHtml2pdf
  },
  name: "Ficha",
  data: () => {
    return {
      date: null,
      days: [{value: "monday", text: "Lunes"}, {value: "tuesday", text: "Martes"}, {
        value: "wednesday",
        text: "Miércoles"
      }, {value: "thursday", text: "Jueves"}, {value: "friday", text: "Viernes"}, {
        value: "saturday",
        text: "Sabado"
      }, {value: "sunday", text: "Domingo"}],
      dialog: false,
      doctor: "",
      especialidad: {},
      especialidades: [],
      events: [],
      filteredDoctors: [],
      filteredSpecialties: [],
      focus: '',
      formTitle: '',
      id: "",
      isEditing: false,
      loading: false,
      medico: {},
      menu: false,
      menu2: false,
      menu3: false,
      menuBirth: false,
      message: "",
      messageColor: "",
      registro: {},
      nuevoRegistro: false,
      nuevoRegistroDisponible: true,
      paciente: {},
      recurringSchedules: [],
      registros: [],
      rut: "",
      rutRules: [
        v => validate(v) || "Rut no es valido"
      ],
      validRut: false,
      validEmail: false,
      search: "",
      selectedElement: null,
      selectedEvent: {},
      selectedOpen: false,
      showMessage: false,
      step: 1,
      type: 'week',
      typeToLabel: {
        // month: 'Mes',
        week: 'Semana',
        day: 'Dia',
        // '4day': '4 Days',
      },
      valid: false,
      short_description: '',
      abogados: ['Michelle Córdova', 'Nicole Ceballos', 'Carolina Cortés', 'Gisselle Arriaza', 'Camilo Troncoso', 'Berenice Garrido', 'Francisca Paillavil', 'Roberto Espinal'],
      abogado: '',
      headersPdf: [
        {text: 'Atención', value: 'doctor_name'},
        {text: 'Categoría', value: 'specialty_name'},
        {text: 'Fecha', value: 'created_at'},
        {text: 'problemática', value: 'short_description'},
        {text: 'Descripcion', value: 'description'},
      ],
      telefonoRules: [
        v => /^569\d{8}$/.test(v) || "Teléfono no es valido"
      ],
      emailRules: [
        v => /.+@.+\..+/.test(v) || "Email debe ser valido"
      ],
      activePicker: null,
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.id = +this.$route.params.id
    } else {
      this.id = +this.$store.state.patientData.id
    }
    this.getPaciente()
    this.medicalRecord()
    this.getEspecialidad()
    this.getMedicalAppointmentById()
  },
  methods: {
    formatRut(rut) {
      this.paciente.rut = format(rut)
      this.validRut = validate(this.paciente.rut)
    },
    getPdfList () {
      this.$refs.html2PdfList.generatePdf()
    },
    getPdfForms () {
      this.$refs.html2PdfForms.generatePdf()
    },
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm')
    },
    async getEspecialidad() {
      let id_especialidad;
      if(this.$route.query.especialidad ) {
        id_especialidad = this.$route.query.especialidad
      } else {
        id_especialidad = this.$store.state.patientData.specialty_id;

/*         const id_doctor = this.$store.state.userData.doctor_id;
        console.log('id doctor',id_doctor);
          const id_especialidad = this.especialidades.map(especialidad => {
            return especialidad.doctors.find(doctor => doctor.id == id_doctor)
          })
        console.log("id especialidad ligada a doctor", id_especialidad); */
      }
      getSpecialtyById(id_especialidad).then(res => {
        this.especialidad = res.especialidades[0]
      })
    },
    async medicalRecord() {
      this.loading = true
      await getMedicalRecords(this.id).then(res => {
        this.registros = res.medicalRecords
        //this.nuevoRegistroDisponible = res.canAddMedicalRecord
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.showMessage = true
        this.message = "Error al cargar registros"
        this.messageColor = "error"
      })
    },
    guardarNuevoRegistro() {
      const data = {
        id_patient: this.id,
        id_doctor: this.$store.state.userData.id,
        id_specialty: this.especialidad.id || '',
        description: `${this.abogado} - ${this.registro.description}`,
        short_description: this.short_description
      }

      console.log(data);
      createMedicalRecord(data).then(res => {
        Swal.fire({
          title: 'Registro guardado',
          icon: 'success',
          confirmButtonText: 'Aceptar',


        }).then(() => {
          this.nuevoRegistro = false
          this.registro = {}
          this.medicalRecord()
        })
       }).catch(err => {
         Swal.fire({
           title: 'Error al guardar registro',
           icon: 'error',
           confirmButtonText: 'Aceptar'
         })
       })
    },
    cancelNuevoRegistro() {
      this.nuevoRegistro = false
      this.registro = {}
    },
    async getPaciente() {
      await getPatientById(this.id).then(response => {
        this.paciente = response
        this.loading = false
      }).catch(error => {
        this.loading = false
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Algo salio mal!',
        })
      })
    },
      getMedicalAppointmentById() {
      const appointmentID = +this.$route.query.appointmentId;
      const data = {id: appointmentID}
      
      getMedicalAppointment_byid(data).then(res => {
        this.short_description = res.medicalAppointments_byid[0].short_description
      })
    },
    agregarRegistro() {
      this.nuevoRegistro = true

      this.registro = {
        doctor: this.$store.state.userData.name,
        specialty: this.especialidad.name || ''
      }
    },
    editPaciente() {
      this.loading = true;
      let data = {
        rut: this.paciente.rut,
        name: this.paciente.name,
        email: this.paciente.email,
        phone: this.paciente.phone,
        address: this.paciente.address,
        birthday: this.paciente.birthday,
      };
      createPatient(data).then(async (response) => {
        this.loading = false;
          await Swal.fire({
            title: 'Usuario Editado',
            text: 'Usuario Editado correctamente',
            icon: 'success',
            confirmButtonText: 'Aceptar'
          })
        })
      .catch((error) => {
        console.log(error);
      });

      this.loading = false;
    },
    saveDateBirth(date) {
      this.$refs.menuBirth.save(date)
    },
  },
    watch: {
    menuBirth(val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    }
    },
  created () {
    getListSpecialties().then(res => {
      this.especialidades = res.especialidades
    });
  },
}
</script>

<style scoped>
.v-main {
 padding: 0 !important;
}
.zind9999999 {
  z-index: 9999999 !important;
  background-color: red;
}
</style>
